<template>
  <div class="page-container">
    <!-- <el-breadcrumb>
      <el-breadcrumb-item>内部转账</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">其他功能</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>SiteConf配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
        <el-input placeholder="请输入confKey" clearable v-model="confKey">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import List from './components/list';
import Create from './components/create';
import moment from 'moment';

export default {
  name: 'TransferInner',
  data() {
    return {
      confKey: ''
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('Siteconf', ['pagination']),
    ...mapGetters('Siteconf', ['list'])
  },
  methods: {
    ...mapActions('Siteconf', ['reqList', 'getCoinTypes']),
    handleSearch() {
      this.reqList({ page: 1,size:25, confKey: this.confKey, });
    },
    getList(data = {}) {
      this.reqList({
       
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    // this.getCoinTypes();
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
